var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2363_605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06348 9.43379V11.379C1.06348 11.4973 1.15963 11.5959 1.28043 11.5959H2.78431C2.90264 11.5959 3.00126 11.4998 3.00126 11.379V7.95703L1.9091 9.04919C1.67735 9.27847 1.38151 9.4116 1.06348 9.43379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75098 7.93237V11.379C3.75098 11.4973 3.84713 11.5959 3.96793 11.5959H5.47181C5.59014 11.5959 5.68876 11.4998 5.68876 11.379V9.34996C5.34607 9.34257 5.02557 9.20697 4.78397 8.96536L3.75098 7.93237Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43799 9.13543V11.3789C6.43799 11.4973 6.53414 11.5959 6.65494 11.5959H8.15882C8.27716 11.5959 8.37577 11.4997 8.37577 11.3789V7.23956L6.65248 8.96286C6.58591 9.02942 6.51441 9.08613 6.43799 9.13543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9178 4.69531L9.12549 6.48764V11.3789C9.12549 11.4973 9.22164 11.5959 9.34244 11.5959H10.8463C10.9647 11.5959 11.0633 11.4997 11.0633 11.3789V4.83091C11.014 4.789 10.977 4.75202 10.9499 4.72736L10.9178 4.69531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1479 1.51993C12.0764 1.4435 11.9679 1.40405 11.8299 1.40405C11.8175 1.40405 11.8027 1.40405 11.7904 1.40405C11.0902 1.4361 10.3925 1.47062 9.69237 1.50267C9.59869 1.5076 9.47049 1.51253 9.36941 1.61361C9.33736 1.64566 9.31271 1.68264 9.29298 1.72702C9.18944 1.95137 9.3349 2.09682 9.40392 2.16585L9.57897 2.34336C9.69977 2.46663 9.82304 2.5899 9.94631 2.7107L5.71573 6.94374L3.81493 5.04294C3.70152 4.92953 3.54867 4.86543 3.38595 4.86543C3.22324 4.86543 3.07285 4.92953 2.95944 5.04294L0.427507 7.57241C0.190831 7.80909 0.190831 8.19122 0.427507 8.4279L0.540914 8.5413C0.654321 8.65471 0.807174 8.71881 0.969889 8.71881C1.1326 8.71881 1.28299 8.65471 1.3964 8.5413L3.38595 6.55175L5.28675 8.45255C5.40016 8.56596 5.55301 8.63006 5.71573 8.63006C5.87844 8.63006 6.02883 8.56596 6.1447 8.45255L10.9177 3.67959L11.4576 4.21704C11.5217 4.28114 11.6104 4.36989 11.746 4.36989C11.8027 4.36989 11.8594 4.3551 11.9186 4.32305C11.9581 4.30086 11.9926 4.27621 12.0222 4.24663C12.1282 4.14062 12.1479 4.00502 12.1528 3.89901C12.1725 3.44538 12.1947 2.99175 12.2169 2.53566L12.249 1.85275C12.2564 1.70976 12.2243 1.59882 12.1479 1.51993Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2363_605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.575aa1548a824feb2b5206fc58ba7b23.svg";
export { ForwardRef as ReactComponent };